import React, { useState } from 'react';
import { Text, ChoiceGroup, Stack, ComboBox, IComboBoxStyles, Dropdown } from '@fluentui/react';
import { onMoveToMap } from "../../Containers/MapView";
import setup from '../../Containers/setup'
import { useSelector } from 'react-redux';
import { onLoadXa } from '../../Containers/ViTriHanhChinh';
import { store } from '../../Redux/Store';
import Type from '../../Redux/Type';

const contentExplanation =
    'Bản đồ sẽ chuyển đến khu vực bạn chọn, chức năng này nhằm giúp bạn định hình khu vực hành chính của địa bàn.';

const Location = () => {

    const stateDiaGioiHC = useSelector(state => state.diaGioi);
    const heightScreenScroll = window.screen.height - (window.screen.height * 0.6);

    const onChangeLocation = (_, option) => {
        let center = {
            lat: parseFloat(option.latitude),
            lng: parseFloat(option.longitude)
        };
        store.dispatch({ type: Type.SET_DIAGIOI, route: 'xaselect', value: option })
        onMoveToMap(center)

        // Tắt form tìm kiếm 
        store.dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'isShowForPopup', value: false });
        store.dispatch({ type: Type.SET_STATE_POPUP_PANEL, route: 'routeContent', value: null });

    };
    const onChangeHuyen = (_, option) => {
        let huyen = { key: option.key, text: option.text }
        let center = {
            lat: parseFloat(option.latitude),
            lng: parseFloat(option.longitude)
        };
        onMoveToMap(center)
        onLoadXa(huyen)
    }
    return (
        <div className='modal-content-container'>
            <div className='animated-panel'>
                <Text variant='xLarge' className='title'>Chuyển vị trí</Text>
                <div>
                    <Text>{contentExplanation}</Text>
                    <br />
                    <br />
                </div>
                <Stack styles={{}} >
                    <Dropdown
                        options={stateDiaGioiHC.menuDiaGioi}
                        selectedKey={stateDiaGioiHC.huyenselect.key}
                        onChange={onChangeHuyen}
                    />
                    {/* <ComboBox
                        defaultSelectedKey={stateDiaGioiHC.huyenselect.key}
                        options={stateDiaGioiHC.menuDiaGioi}
                        allowFreeform
                        autoComplete="on"
                        dropdownWidth="400px"
                        onChange={onChangeHuyen}
                    /> */}

                </Stack>
                <Stack styles={styles.container(heightScreenScroll)} >
                    <ChoiceGroup
                        style={{ paddingBottom: 30, paddingTop: 10 }}
                        selectedKey={stateDiaGioiHC.xaselect ? stateDiaGioiHC.xaselect.key : null}
                        options={stateDiaGioiHC.menuDiaGioi.filter(e => e.key === stateDiaGioiHC.huyenselect.key)[0]['arrXa']}
                        onChange={onChangeLocation}
                    //label="Chuyển vị trí đến :"
                    />
                </Stack>
            </div>
        </div>
    )
};

export default Location;


const styles = {
    container: (heightScreenScroll) => ({
        root: {
            paddingBottom: 20,
            flex: 1,
            overflowY: 'scroll',
            maxHeight: heightScreenScroll,
            //maxHeight:'calc(100% - 230px)', 
            marginRight: -16,
            paddingRight: 16,
        }
    }
    )
};




